import { Component } from '@angular/core';

@Component({
  selector: 'app-route-noop',
  templateUrl: './route-noop.component.html',
  styleUrls: ['./route-noop.component.scss'],
})
export class RouteNoopComponent {}
